$(() => {
    if (window.location.pathname !== '/' || (window.location.search && window.location.pathname === '/')) {
        const header = $('#ieric-header-desktop, #ieric-header-mobile');
        header.addClass('background-gradient');
    }
});

$(window).on('scroll', () => {
    if (window.location.pathname !== '/' || (window.location.search && window.location.pathname === '/')) return;
    const header = $('#ieric-header-desktop, #ieric-header-mobile');
    if ($(window).scrollTop() > 200) {
        header.addClass('background-gradient');
    } else {
        header.removeClass('background-gradient');
    }
});

$('#bars').on('click', () => {
    $('#mobileNav').addClass('opened');
    $('html').addClass('no-scroll');
});

$('#close-nav').on('click', () => {
    $('#mobileNav').removeClass('opened');
    $('html').removeClass('no-scroll');
});